module.exports = __webpack_public_path__ + "img/debesteslagerij.7798a379.webp";